import HeroSection from '../../components/LocationPages/HeroSection';
import MiddleSection from '../../components/LocationPages/MiddleSection';

const data = {
  seo: {
    title: 'Financial Planner in Orange NSW | PFGS Regional Office',
    description:
      'Financial planning, super and investment advice from PFGS in Orange NSW. Local advisors and a free initial consultation.',
    canonical: 'https://pfgs.com.au/location-orange',
  },
  heroTitle: 'Your Trusted Financial Planning Experts in Orange',
  heroDescription: 'Office 4, 3 Hampden Avenue, Orange NSW 2800, Australia',
  location: 'Orange',
  mainTitle: 'Personalised Financial Advice to Build a Stronger Financial Future',
  introText: [
    'At PFGS, we’re proud to support residents and families across Hampden Avenue and the Orange region with expert, transparent, and tailored financial advice. Whether you’re planning for retirement, buying your first home, managing debt, or looking to grow your investments, our local financial advisors in Orange are here to guide you toward long-term success.',
    'We understand the unique financial landscape of Orange — from its growing property market to regional investment opportunities — and provide advice that’s grounded in local experience and personalised strategy.',
  ],
  whyChooseTitle: 'Why Choose PFGS as Your Orange Financial Advisor?',
  reasons: [
    {
      title: 'Local Expertise:',
      description: 'We understand the Orange community, economy, and financial trends — helping you make confident, well-informed decisions.',
    },
    {
      title: 'Comprehensive Financial Planning:',
      description: 'From superannuation and insurance to budgeting and wealth creation, we offer full-service financial support.',
    },
    {
      title: 'Independent & Transparent Advice:',
      description: ' No sales targets, no product bias — just genuine financial guidance focused on your best interests.',
    },
    {
      title: 'Ongoing Support:',
      description: 'We don’t just create a plan and leave. We’re here to review, adjust, and support your financial growth over time.',
    },
    {
      title: 'Tailored Solutions:',
      description: 'Every plan we create is built around your personal goals and financial situation — not a one-size-fits-all template.',
    },
  ],
  servicesTitle: 'Our Financial Services in Orange',
  services: [
    {
      title: '1. Financial Planning',
      description:
        'We work with Orange locals to build structured, realistic plans that achieve both short- and long-term goals — from savings strategies to retirement readiness.',
      bullets: [],
    },
    {
      title: '2. Investment Strategy & Wealth Building',
      description:
        'Our advisors help you grow and protect your wealth through strategic investment planning, designed to balance opportunity and risk.',
    },
    {
      title: '3. Retirement Planning & Superannuation',
      description:
        'Secure your future with smart retirement planning. We’ll help you make the most of your super and plan for a comfortable, confident retirement.',
    },
    {
      title: '4. Insurance & Risk Protection',
      description: 'Protect what matters most — your family, income, and assets — with the right insurance strategies tailored to your needs.',
    },
    {
      title: '5. Debt Strategy & Cash Flow Management',
      description:
        'We’ll help you reduce debt faster, improve budgeting, and free up cash flow to make your financial life more stable and stress-free.',
    },
  ],
  whoWeHelpTitle: 'Who We Help',
  whoWeHelp: [
    {
      title: 'Professionals & Families:',
      description: 'Balancing lifestyle goals with long-term financial security.',
    },
    {
      title: 'Entrepreneurs & Business Owners:',
      description: 'Structuring finances for growth, cash flow, and tax efficiency.',
    },
    {
      title: 'First Home Buyers:',
      description: 'Building smart strategies for entering the Orange property market.',
    },
    {
      title: 'Investors:',
      description: 'Creating sustainable portfolios to build wealth with confidence.',
    },
    {
      title: 'Pre-Retirees & Retirees:',
      description: 'Making your super work harder for a secure and comfortable future.',
    },
  ],
  aboutTitle: 'About PFGS – Financial Planning in Orange',
  aboutText: [
    'At PFGS, we believe financial advice should be simple, honest, and empowering. Our financial advisors in Mohali are dedicated to helping you make confident decisions that align with your goals. With our client-first approach and continuous support, we make sure your finances work as hard as you do.',
  ],
  ctaTitle: 'Start Building Your Financial Future Today',
  ctaText:
    'At PFGS, we believe in clear, practical, and honest financial advice. Our Orange financial advisors focus on helping you make informed choices that align with your goals and values. With a commitment to trust and transparency, we provide the tools and guidance to help you take control of your financial future. Take the First Step Toward Financial Confidence Start planning your financial future today with PFGS – your trusted financial advisors in Orange, NSW. Contact us now for your free initial consultation and discover how we can help you achieve your financial goals.',
  sidebarTitle: 'Ready To Get Started?',
  sidebarText: 'Speak with one of our experienced financial advisors to discover your options and available opportunities in Orange.',
};

const OrangeLocation = () => {
  return (
    <div>
      <HeroSection data={data} />
      <MiddleSection data={data} />
    </div>
  );
};

export default OrangeLocation;
